import { render, staticRenderFns } from "./AlertRSTriggersTable.vue?vue&type=template&id=ede1ec48&scoped=true&"
import script from "./AlertRSTriggersTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSTriggersTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSTriggersTable.vue?vue&type=style&index=0&id=ede1ec48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede1ec48",
  null
  
)

export default component.exports